export default __webpack_public_path__ + "static/UAP-footer-86faa12306c9128239c8c865e6643982.png";